/**
 * PAPPO — useSocket hook
 * Gere a conexão WebSocket e ouve eventos específicos.
 */

import { useEffect, useRef, useCallback } from 'react';
import { getSocket, disconnectSocket } from '../services/socket';
import type { Socket } from 'socket.io-client';

interface UseSocketOptions {
  /** Se false, não conecta automaticamente */
  autoConnect?: boolean;
}

export function useSocket(options: UseSocketOptions = {}) {
  const { autoConnect = true } = options;
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    if (autoConnect) {
      socketRef.current = getSocket();
    }
    return () => {
      /* Não desconecta no unmount — singleton partilhado */
    };
  }, [autoConnect]);

  /** Emitir um evento */
  const emit = useCallback((event: string, data?: unknown) => {
    const socket = socketRef.current || getSocket();
    socket.emit(event, data);
  }, []);

  /** Ouvir um evento (com cleanup automático) */
  const on = useCallback((event: string, handler: (...args: unknown[]) => void) => {
    const socket = socketRef.current || getSocket();
    socket.on(event, handler);
    return () => { socket.off(event, handler); };
  }, []);

  return { emit, on, disconnect: disconnectSocket };
}
